var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0455 37.7H6.45455C5.27313 37.7 4.1401 37.2575 3.30471 36.4699C2.46932 35.6822 2 34.614 2 33.5V12.5C2 11.3861 2.46932 10.3179 3.30471 9.5302C4.1401 8.74255 5.27313 8.30005 6.45455 8.30005H17.5909",
    stroke: "#868686",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2L19.6818 8.3L13 14.6",
    stroke: "#868686",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7272 43.6L26.0454 37.3L32.7272 31",
    stroke: "#868686",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8.30005H39.5909C40.7723 8.30005 41.9054 8.74255 42.7407 9.5302C43.5761 10.3179 44.0455 11.3861 44.0455 12.5V33.5C44.0455 34.614 43.5761 35.6822 42.7407 36.4699C41.9054 37.2575 40.7723 37.7 39.5909 37.7H28.4545",
    stroke: "#868686",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6818 29.6C27.3721 29.6 30.3636 26.7794 30.3636 23.3C30.3636 19.8206 27.3721 17 23.6818 17C19.9916 17 17 19.8206 17 23.3C17 26.7794 19.9916 29.6 23.6818 29.6Z",
    stroke: "#868686",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchCamera);
export default __webpack_public_path__ + "static/media/SwitchCamera.7c822d84309862b2daa0e20f8d4dc81c.svg";
export { ForwardRef as ReactComponent };